/**
 * Implements scroll assist for elements that are inside a horizontally scrollable element.
 *
 * The assist does the following:
 *
 * - Scrolls horizontally to elements when they are focused (and out of view)
 * - Sets a variable to manage the gaps of the elements so that if elements are out of view, they
 *   are split from the middle, to indicate to the user there are more elements to scroll
 */
(() => {
    /**
     * How much an element's cut off can be off-center before it is no longer considered to be split
     * from the middle.
     */
    const errorMarginPercentage = 30;

    let containers = document.querySelectorAll(
        '.js-horizontal-scroll-assist-container'
    );

    if (!containers.length) {
        return;
    }

    function setGap(container, gap) {
        // console.log('Scroll assist gap set to ' + gap);
        container.style.setProperty('--scroll-assist-gap', `${gap}px`);
    }

    function updateGaps() {
        // console.log('Refreshing scroll assist gaps...');

        containers.forEach((container) => {
            if (container.scrollLeft !== 0) {
                return;
            }
            setGap(container, 0);

            let targets = container.querySelectorAll(
                '.js-horizontal-scroll-assist-target'
            );

            let previousElementWidth = 0;
            let previousElementOffsetRight = 0;

            for (let i = 0; i < targets.length; i++) {
                const isPeeking =
                    container.clientWidth <
                    targets[i].offsetLeft + targets[i].clientWidth;

                if (!isPeeking) {
                    previousElementWidth = targets[i].offsetWidth;
                    previousElementOffsetRight =
                        targets[i].offsetLeft + targets[i].offsetWidth;
                    continue;
                }

                if (i === 0) {
                    return;
                }

                // console.log('Element ' + (i + 1) + ' is peeking');

                // console.log('container.clientWidth', container.clientWidth);
                // console.log('element width', targets[i].clientWidth);
                // console.log('element offset', targets[i].offsetLeft);
                const peek = container.clientWidth - targets[i].offsetLeft;
                // console.log('peek', peek);
                const inversePeek =
                    targets[i].offsetLeft +
                    targets[i].offsetWidth -
                    container.clientWidth;
                // console.log('inversePeek', inversePeek);
                // console.log(
                //     'lastElementOffsetRight',
                //     previousElementOffsetRight
                // );

                const gap = targets[i].offsetLeft - previousElementOffsetRight;

                // console.log('gap', gap);

                const halfOfCurrentElement = targets[i].offsetWidth / 2;
                const minimumPeek =
                    halfOfCurrentElement -
                    (errorMarginPercentage / 100) * targets[i].offsetWidth;

                if (i !== 1 && peek < minimumPeek) {
                    const halfOfPreviousElement = previousElementWidth / 2;
                    const distanceToMiddleOfPreviousElement =
                        halfOfPreviousElement + gap + peek;
                    const gapAmount = i - 1;
                    setGap(
                        container,
                        distanceToMiddleOfPreviousElement / gapAmount
                    );
                } else if (targets.length > 2 && inversePeek < minimumPeek) {
                    const distanceToMiddleOfCurrentElement =
                        peek - halfOfCurrentElement;
                    const gapAmount = i;
                    setGap(
                        container,
                        distanceToMiddleOfCurrentElement / gapAmount
                    );
                }

                // Debug
                // else {
                //     console.log('Adjustment not required or cut off is within error margin');
                // }

                return;
            }
        });
    }

    function findTarget(element) {
        // console.log('Finding target...');

        if (element.classList.contains('js-horizontal-scroll-assist-target')) {
            return element;
        }

        if (
            element.nextElementSibling.classList.contains(
                'js-horizontal-scroll-assist-target'
            )
        ) {
            return element.nextElementSibling;
        }

        return element;
    }

    function scrollTo(target) {
        // console.log('Scrolling to element...');

        if (!target) {
            return;
        }

        let container = target.closest(
            '.js-horizontal-scroll-assist-container'
        );

        if (!container) {
            return;
        }

        // console.log('container.clientWidth', container.clientWidth);
        // console.log('container.scrollLeft', container.scrollLeft);
        // console.log('container.offsetLeft', container.offsetLeft);
        // console.log('target.clientWidth', target.clientWidth);
        // console.log('target.offsetLeft', target.offsetLeft);

        if (container.clientWidth < target.offsetLeft + target.clientWidth) {
            container.scrollLeft = target.offsetLeft - container.offsetLeft;
        }

        if (container.scrollLeft > target.offsetLeft) {
            const isSmallOffset = target.offsetLeft < 35;
            container.scrollLeft = isSmallOffset
                ? 0
                : target.offsetLeft - container.offsetLeft;
        }
    }

    containers.forEach((container) => {
        let triggers = container.querySelectorAll(
            '.js-horizontal-scroll-assist-trigger'
        );

        if (!triggers.length) {
            return;
        }

        triggers.forEach((trigger) => {
            trigger.addEventListener('focus', (e) => {
                scrollTo(findTarget(e.currentTarget));
            });
        });
    });

    // update scrollable item gaps on resize
    window.addEventListener('resize-debounce', updateGaps);

    updateGaps();
})();
